var _style, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DC8181;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_00000078042640677175527580000006528027856631326873_);}\r\n\t.st3{fill:url(#SVGID_00000078726874882349423270000012580258774335950523_);}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.52,129.32c0.18,0.34,0.36,0.68,0.54,1.02C65.88,130,65.7,129.66,65.52,129.32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.03,128.8c0.17,0.18,0.34,0.35,0.51,0.53C65.37,129.15,65.2,128.98,65.03,128.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.07,130.35c0.16,0.21,0.33,0.41,0.49,0.62C66.4,130.77,66.23,130.56,66.07,130.35z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.1267,
    y1: 180,
    x2: 181.5492,
    y2: 180
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#26EBE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#004DFE"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.72,187.26v25.19h84.83v21.63H66.13V125.92h95.3l20.12,21.63H96.72v18.08h77.57v21.63H96.72z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108277193549613305960000015111919212436550333_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.876,
    y1: 180,
    x2: 294.3622,
    y2: 180
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#26EBE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#004DFE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108277193549613305960000015111919212436550333_)"
    },
    d: "M224.06,234.08v-3.55 c0-4.95,0.54-9.94,1.62-14.99c1.08-5.05,2.52-9.97,4.33-14.76c1.8-4.79,3.84-9.45,6.1-13.98c2.26-4.53,4.58-8.75,6.95-12.67 c5.46-9.27,11.74-18.13,18.85-26.58h-71.3l-20.73-21.63h124.49v21.63c-8.04,8.45-15.25,17.31-21.63,26.58 c-2.68,3.92-5.33,8.14-7.96,12.67c-2.63,4.53-4.95,9.19-6.95,13.98c-2.01,4.79-3.63,9.71-4.87,14.76 c-1.24,5.05-1.85,10.04-1.85,14.99v3.55H224.06z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060709978488300520050000006482885677185911450_",
    gradientUnits: "userSpaceOnUse",
    x1: 278.7817,
    y1: 236.9496,
    x2: -16.7927,
    y2: 66.5451
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#26EBE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#004DFE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060709978488300520050000006482885677185911450_)"
    },
    d: "M304.6,245.01H55.4V114.99h249.2V245.01z  M60.66,239.74h238.67V120.26H60.66V239.74z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b00f4cc2632aea1f1f66f4c77f131331.svg";
export { ForwardRef as ReactComponent };